import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'

interface Props {
  modelValue: boolean
  isPrint: boolean
}

interface Emits {
  (e: 'modelValue', value: boolean): void
  (e: 'check-printed'): void
  (e: 'check-failed'): void
  (e: 'close'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCheckPrint',
  props: {
    modelValue: { type: Boolean },
    isPrint: { type: Boolean }
  },
  emits: ["modelValue", "check-printed", "check-failed", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'modelValue', value: boolean): void
  (e: 'check-printed'): void
  (e: 'check-failed'): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean
  isPrint: boolean
}



const modalRef = ref<HTMLElement | null>(null)

onMounted(() => {
  if (modalRef.value && modalRef.value.parentNode !== document.body) {
    document.body.appendChild(modalRef.value)
  }
})

onBeforeUnmount(() => {
  if (modalRef.value?.parentNode) {
    modalRef.value.parentNode.removeChild(modalRef.value)
  }
})

watch(() => props.isPrint, (newValue, oldValue) => {
  if (oldValue === true && newValue === false) {
    handleClose()
  }
})

const handleClose = () => {
  emit('modelValue', false)
  emit('close')
}

const handleOverlayClick = (event: MouseEvent) => {
  if (!props.isPrint) {
    if (event.target === event.currentTarget) {
      handleClose()
    }
  }
}

return { __sfc: true,props, emit, modalRef, handleClose, handleOverlayClick }
}

})